import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import {
  useQueryDeleteFiles,
  useQueryGetFiles,
} from 'v2/resources/hooks/services/files/useFiles';
import { IFileByGetResponse } from 'v2/resources/services/files/types';

//TODO: REFACTOR IN UPDATE REACT
const useListFiles = () => {
  const navigate = useHistory();

  const {
    isLoading: isLoadingGetFiles,
    data: dataGetFiles,
    refetch: refetchGetFiles,
  } = useQueryGetFiles();

  const {
    isLoading: isLoadingDeleteFiles,
    mutateAsync: mutateAsyncDeleteFiles,
  } = useQueryDeleteFiles();

  const [dataModalConfirmDelete, setDataModalConfirmDelete] =
    useState<IFileByGetResponse | null>(null);

  const handleDownloadDocument = (url: string) => {
    window.open(url, '_blank');
  };

  const handleNavigateEditFile = (file: IFileByGetResponse, index: number) => {
    navigate.push({
      pathname: `/edit-files-ai`,
      state: { file },
    });
  };

  const handleOpenModalConfirmDelete = (file: IFileByGetResponse) => {
    setDataModalConfirmDelete(file);
  };

  const handleCloseModalConfirmDelete = () => {
    setDataModalConfirmDelete(null);
  };

  const handleDeleteFile = async () => {
    if (dataModalConfirmDelete) {
      await mutateAsyncDeleteFiles(dataModalConfirmDelete.id);
      refetchGetFiles();
      handleCloseModalConfirmDelete();
      return;
    }
  };

  const files = dataGetFiles?.data || ([] as IFileByGetResponse[]);

  return {
    files,
    isLoadingGetFiles,
    dataModalConfirmDelete,
    isLoadingDeleteFiles,
    handleNavigateEditFile,
    handleDownloadDocument,
    handleOpenModalConfirmDelete,
    handleCloseModalConfirmDelete,
    handleDeleteFile,
  };
};

export default useListFiles;
